const LS_KEY = "traffic_source_v1";

export function readTrafficSource() {
	if (typeof window === "undefined") return null;
	try {
		const raw = window.localStorage.getItem(LS_KEY);
		if (!raw) return null;
		return JSON.parse(raw);
	} catch (e) {
		return null;
	}
}

export function writeTrafficSource(value) {
	if (typeof window === "undefined") return;
	try {
		window.localStorage.setItem(LS_KEY, JSON.stringify(value));
	} catch (e) {
		// ignore
	}
}

export function captureTrafficSourceFromUrl() {
	if (typeof window === "undefined") return;

	const url = new URL(window.location.href);
	const now = new Date().toISOString();

	const gclid = url.searchParams.get("gclid");
	const gbraid = url.searchParams.get("gbraid");
	const wbraid = url.searchParams.get("wbraid");
	const gad_campaignid = url.searchParams.get("gad_campaignid");

	const hasAdsParam = !!gclid || !!gbraid || !!wbraid || !!gad_campaignid;

	const SESSION_KEY = "ads_session_v1";
	if (hasAdsParam) {
		try {
			window.sessionStorage.setItem(SESSION_KEY, "1");
		} catch (e) {}
	}

	let isGoogleAdsThisTouch = hasAdsParam;

	if (!isGoogleAdsThisTouch) {
		try {
			const sessionFlag = window.sessionStorage.getItem(SESSION_KEY);
			if (sessionFlag === "1") isGoogleAdsThisTouch = true;
		} catch (e) {}
	}

	const existing = readTrafficSource();

	const current = {
		source: isGoogleAdsThisTouch ? "google_ads" : "non_ads",

		gclid: gclid || existing?.gclid || undefined,
		gbraid: gbraid || existing?.gbraid || undefined,
		wbraid: wbraid || existing?.wbraid || undefined,
		gad_campaignid: gad_campaignid || existing?.gad_campaignid || undefined,

		landing_url: window.location.href,
		referrer: document.referrer || "",
		first_seen_at: existing?.first_seen_at || now,
		last_seen_at: now,
	};

	writeTrafficSource(current);
}
